// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Gracias test Match con el snapshot 1`] = `""`;
